import { axiosObject } from "../config";

export default function contactUs(data: any) {
  let payload = data;
  payload["topic"] = data.topic.label;

  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/contact-us-requests/_create";

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
